import { render, staticRenderFns } from "./RowNewSection.vue?vue&type=template&id=1be7de0a&"
import script from "./RowNewSection.vue?vue&type=script&lang=js&"
export * from "./RowNewSection.vue?vue&type=script&lang=js&"
import style0 from "./RowNewSection.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports